import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-the-page-a01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "c-common-inner p-the-page-a01__lead" }
const _hoisted_5 = {
  key: 0,
  id: "thanks-point-area",
  class: "p-the-page-a01__thanks"
}
const _hoisted_6 = { class: "c-common-inner" }
const _hoisted_7 = { class: "p-the-page-a01__body" }
const _hoisted_8 = { class: "p-the-page-a01__main" }
const _hoisted_9 = { class: "p-the-page-a01__section" }
const _hoisted_10 = { class: "p-the-page-a01__item_list" }
const _hoisted_11 = { class: "p-the-page-a01__item_list" }
const _hoisted_12 = { class: "p-the-page-a01__item_list" }
const _hoisted_13 = { class: "p-the-page-a01__item_list" }
const _hoisted_14 = { class: "c-common-inner" }
const _hoisted_15 = { class: "p-the-page-a01__news" }
const _hoisted_16 = { class: "c-common-inner" }
const _hoisted_17 = { class: "p-the-page-a01__item_list" }
const _hoisted_18 = { class: "p-the-page-a01__item_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_CMS = _resolveComponent("CMS")!
  const _component_PointNavi = _resolveComponent("PointNavi")!
  const _component_TheA01PointInfoPanel = _resolveComponent("TheA01PointInfoPanel")!
  const _component_TheA01PointNoticeCard = _resolveComponent("TheA01PointNoticeCard")!
  const _component_TheA01WhatsNewNoticePanel = _resolveComponent("TheA01WhatsNewNoticePanel")!
  const _component_A01Heading = _resolveComponent("A01Heading")!
  const _component_TheA01MessagePanel = _resolveComponent("TheA01MessagePanel")!
  const _component_TheA01GiftMeritPanel = _resolveComponent("TheA01GiftMeritPanel")!
  const _component_TheA01EarnPointPanel = _resolveComponent("TheA01EarnPointPanel")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_LoadingProcess = _resolveComponent("LoadingProcess")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TheHeader, {
          ref: "theHeader",
          onUserProfileSummary: _ctx.applyUserProfileSummary
        }, null, 8, ["onUserProfileSummary"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CMS, {
            contents_type: "special_page",
            view_type: "carousel",
            page_limit: "5",
            view_area: "top",
            show_more: false
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PointNavi, { "grant-criteria-count": _ctx.grantCriteriaCount }, null, 8, ["grant-criteria-count"]),
          _createElementVNode("div", {
            class: _normalizeClass(["p-the-page-a01__point-summary", {
              'p-the-page-a01__point-summary--with-notice':
                _ctx.pointNoticeCards.length > 0
            }])
          }, [
            (_ctx.theA01PointInfo.pointsLoaded)
              ? (_openBlock(), _createBlock(_component_TheA01PointInfoPanel, {
                  key: 0,
                  "exchange-points": _ctx.isGroupBudget ? _ctx.theA01PointInfo.groupBudgetPoint : _ctx.theA01PointInfo.exchangePoints,
                  "thanks-exclusive-points": _ctx.theA01PointInfo.thanksExclusivePoints,
                  "exchange-expire-nearest-date": _ctx.theA01PointInfo.exchangeExpireNearestDate,
                  "exchange-expire-nearest-points": _ctx.theA01PointInfo.exchangeExpireNearestPoints,
                  "thanks-exclusive-expire-nearest-date": _ctx.theA01PointInfo.thanksExclusiveExpireNearestDate,
                  "thanks-exclusive-expire-nearest-points": _ctx.theA01PointInfo.thanksExclusiveExpireNearestPoints,
                  class: "p-the-page-a01__point-info"
                }, null, 8, ["exchange-points", "thanks-exclusive-points", "exchange-expire-nearest-date", "exchange-expire-nearest-points", "thanks-exclusive-expire-nearest-date", "thanks-exclusive-expire-nearest-points"]))
              : _createCommentVNode("", true),
            (_ctx.pointNoticeCards.length > 0)
              ? (_openBlock(), _createBlock(_component_TheA01PointNoticeCard, {
                  key: 1,
                  "point-notice-cards": _ctx.pointNoticeCards,
                  class: "p-the-page-a01__point-notice"
                }, null, 8, ["point-notice-cards"]))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_component_TheA01WhatsNewNoticePanel),
          (_ctx.isGroupBudget == false && _ctx.thanksFunctionEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_A01Heading, {
                  title: _ctx.thanksPointName,
                  class: "p-the-page-a01__section__heading p-the-page-a01__section__heading--thanks"
                }, null, 8, ["title"]),
                _createVNode(_component_TheA01MessagePanel, { messages: _ctx.messages }, null, 8, ["messages"]),
                _createVNode(_component_TheA01GiftMeritPanel)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          id: "product-exchange-area",
          class: "p-the-page-a01__exchange",
          style: _normalizeStyle({
            '--site-light-color': _ctx.lightColorCode
          })
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_A01Heading, {
                    title: "商品交換",
                    class: "p-the-page-a01__section__heading p-the-page-a01__section__heading--exchange",
                    "show-button": true
                  }),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_CMS, {
                      contents_type: "block_contents",
                      location_code: "IC_TOP_01_001_menutitle"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_CMS, {
                      contents_type: "block_contents",
                      location_code: "IC_TOP_01_002_menu"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_CMS, {
                      contents_type: "block_contents",
                      location_code: "IC_TOP_01_003_rankingtitle"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_CMS, {
                      contents_type: "block_contents",
                      location_code: "IC_TOP_01_004_ranking"
                    })
                  ])
                ])
              ])
            ])
          ])
        ], 4),
        _createVNode(_component_TheA01EarnPointPanel, {
          id: "earn-point-area",
          conditions: _ctx.grantCriteriaList,
          "grant-criteria-count": _ctx.grantCriteriaCount
        }, null, 8, ["conditions", "grant-criteria-count"]),
        _withDirectives(_createElementVNode("div", {
          class: "p-the-page-a01__faq",
          style: _normalizeStyle({
            '--site-light-color': _ctx.lightColorCode
          })
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_CMS, {
              contents_type: "block_contents",
              location_code: "IC_TOP_01_007_faq",
              onHasContents: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hasFaqContents = $event))
            })
          ])
        ], 4), [
          [_vShow, _ctx.hasFaqContents]
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_CMS, {
                contents_type: "block_contents",
                location_code: "IC_TOP_01_005_newstitle"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_CMS, {
                contents_type: "block_contents",
                location_code: "IC_TOP_01_006_news"
              })
            ])
          ])
        ])
      ]),
      _createVNode(_component_FloatingGivePointButton),
      _createVNode(_component_TheFooter),
      _createVNode(_component_LoadingProcess)
    ])
  ]))
}